import './GroupHeader.less';

import PropTypes from 'prop-types';

import { LogoGovbr } from '../../../layout';

// TODO: i18n
const GroupHeader = ({
  title,
  description,
  logo,
  active,
  collapsible,
  onClick,
}) => {
  if (!title && !logo) return null;

  const baseClass = 'br-group-header';

  const buttonClass = collapsible
    ? `${baseClass} ${baseClass}--${active ? 'open' : 'close'}`
    : `${baseClass} ${baseClass}--header`;

  return (
    <button className={buttonClass} onClick={() => onClick && onClick()}>
      {title && !logo && (
        <div className={`${baseClass}__wrapper`}>
          <div className={`${baseClass}__title`}>{title}</div>
          {description && (
            <div className={`${baseClass}__description`}>{description}</div>
          )}
        </div>
      )}

      {logo && (
        <div className={`${baseClass}__logo`}>
          <LogoGovbr title="Menu do Gov.br" title-id="gov-menu-logo" />
        </div>
      )}

      {collapsible && (
        <span className="br-button circle small">
          <i
            className={`fa-solid fa-${active ? 'angle-up' : 'angle-down'}`}
          ></i>
        </span>
      )}
    </button>
  );
};

GroupHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  logo: PropTypes.bool,
  active: PropTypes.bool,
  collapsible: PropTypes.bool,
  onClick: PropTypes.func,
};

export default GroupHeader;
